import axios from 'axios';
import { token } from '../../../services/Apis';
import { juegosDeportivosApi } from '../../sistema/deportes/DeportesService';

export const EQUIPOS_CONST = 'equipos';

export const allEquiposService = async (params) => {
  const res = await axios.get(`${juegosDeportivosApi}/${EQUIPOS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveEquiposService = async (id, data) => {
  if (id) {
    return await axios.patch(
      `${juegosDeportivosApi}/${EQUIPOS_CONST}/${id}`,
      data,
      {
        headers: token({}),
      },
    );
  }
  return await axios.post(`${juegosDeportivosApi}/${EQUIPOS_CONST}`, data, {
    headers: token({}),
  });
};

export const oneEquiposService = async (id) => {
  const res = await axios.get(`${juegosDeportivosApi}/${EQUIPOS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteEquiposService = async (id) => {
  const res = await axios.delete(
    `${juegosDeportivosApi}/${EQUIPOS_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};
